var _g, _g2, _g3, _g4, _g5, _defs;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSecondTop = function SvgSecondTop(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 193,
    height: 81,
    viewBox: "0 0 193 81",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.2391 38.2699C34.2641 26.4687 39.6368 27.1727 45 25C53.5583 25 35.7833 32.5 32.196 39.1409C25.5078 51.5222 27.0698 62.2999 28.8568 67.8071C29.2455 68.5642 29.6312 69.2944 30 70C31.5905 73.0429 30.1635 71.834 28.8568 67.8071C25.2771 60.8334 21.4455 51.5767 28.2391 38.2699Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3942 20.8339C28.1447 20.4172 27.073 18.3829 28.1674 18.0356C29.2618 17.6883 28.8843 19.9819 29.666 20.5028C30.4477 21.0237 30.4477 20.3292 31.6985 19.9819C32.9493 19.6346 33.262 21.5447 32.793 22.2393C32.3239 22.9338 30.4477 22.4129 30.4477 23.1075C30.4477 23.8021 30.8737 26 29.1339 26C28.3529 26 28.7473 23.1075 27.6335 23.1075C25.7316 23.1075 25.1185 23.1019 25.0071 22.2393C24.8813 21.2644 26.4561 21.3548 27.3942 20.8339Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_0_1)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 51.5,
    r: 1.5,
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_f_0_1)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 23,
    cy: 71.5,
    rx: 1,
    ry: 0.5,
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_f_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.1601 31.233C50.2023 35.5289 44.0114 39.8773 32.9672 55.1993C29.1079 68.266 14.6705 69.2742 14.7994 60.0965L14.8012 59.9704C14.9307 50.6798 15.2955 24.5186 61.0428 16.4827C103.52 9.02133 140.241 25.486 165.754 44.8961C173.687 50.932 190.577 67.2758 164.704 49.2495C127.773 23.5194 95.7517 21.5095 64.1601 31.233Z",
    fill: "currentColor",
    fillOpacity: 0.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_0_1",
    x: 20.4906,
    y: 21,
    width: 30.8137,
    height: 54.7058,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_0_1",
    x: 23,
    y: 16,
    width: 12,
    height: 12,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_0_1",
    x: 10,
    y: 48,
    width: 7,
    height: 7,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_f_0_1",
    x: 21,
    y: 70,
    width: 4,
    height: 3,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "effect1_foregroundBlur_0_1"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_f_0_1",
    x: 0.798553,
    y: 0.64856,
    width: 191.737,
    height: 79.4885,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    "in": "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 7,
    result: "effect1_foregroundBlur_0_1"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSecondTop, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/secondTop.053902fd.svg";
export { ForwardRef as ReactComponent };